"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Column = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Column = function Column(props) {
  var children = props.children,
      classNames = props.classNames,
      withShadow = props.withShadow;
  var columnClassNames = {
    column: true,
    'column--with-shadow': withShadow
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(columnClassNames, classNames)
  }, children);
};

exports.Column = Column;
Column.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.oneOf([null])]),
  classNames: _propTypes.default.any.isRequired,
  withShadow: _propTypes.default.bool.isRequired
};
Column.displayName = 'Column';
var defaultProps = {
  children: null,
  classNames: {},
  withShadow: false
};
Column.defaultProps = defaultProps;
var _default = Column;
exports.default = _default;